/* TDP - FAQ (section tdp-faq) : boutons de partage de chaque question,
   copie du lien, recherche dans les questions (et onglets, si un jour il y
   en a). Repris du script qui etait dans le contenu de la page. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.tdpFaqReady) return;
    root.dataset.tdpFaqReady = '1';

    var tabs = root.querySelectorAll('.tdp-faq-tab');
    var panels = root.querySelectorAll('.tdp-faq-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var target = root.querySelector('#' + tab.dataset.tab);
        if (target) target.classList.add('is-active');
      });
    });

    var shareIcons = function (url) {
      var encoded = encodeURIComponent(url);
      return (
        '<a href="https://www.facebook.com/sharer/sharer.php?u=' + encoded + '" target="_blank" rel="noopener" aria-label="Partager sur Facebook">' +
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.91h2.54V9.83c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.2 2.23.2v2.45h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.91h-2.34V22c4.78-.79 8.44-4.94 8.44-9.94z"/></svg>' +
        '</a>' +
        '<a href="https://twitter.com/intent/tweet?url=' + encoded + '" target="_blank" rel="noopener" aria-label="Partager sur X">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M18.9 2H22l-7.2 8.2L23 22h-6.9l-5.4-6.9L4.6 22H1.5l7.7-8.8L1 2h7l4.9 6.3L18.9 2z"/></svg>' +
        '</a>' +
        '<a href="https://www.linkedin.com/sharing/share-offsite/?url=' + encoded + '" target="_blank" rel="noopener" aria-label="Partager sur LinkedIn">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M4.98 3.5C4.98 4.9 3.9 6 2.5 6S0 4.9 0 3.5 1.1 1 2.5 1s2.48 1.1 2.48 2.5zM.2 8.98h4.6V23H.2V8.98zM8.4 8.98h4.4v1.9h.06c.6-1.15 2.1-2.36 4.3-2.36 4.6 0 5.45 3.03 5.45 6.98V23h-4.6v-6.6c0-1.57-.03-3.6-2.2-3.6-2.2 0-2.53 1.72-2.53 3.48V23H8.4V8.98z"/></svg>' +
        '</a>' +
        '<button type="button" class="tdp-faq-copy" data-url="' + url + '" aria-label="Copier le lien">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 0 0 7.07 0l1.41-1.41a5 5 0 0 0-7.07-7.07L10 6"/><path d="M14 11a5 5 0 0 0-7.07 0L5.52 12.4a5 5 0 0 0 7.07 7.07L14 18"/></svg>' +
        '</button>'
      );
    };

    root.querySelectorAll('.tdp-faq-share').forEach(function (el) {
      var url = window.location.origin + window.location.pathname + '#' + el.dataset.anchor;
      el.innerHTML = shareIcons(url);
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.tdp-faq-copy');
      if (!btn) return;
      e.preventDefault();
      navigator.clipboard && navigator.clipboard.writeText(btn.dataset.url).then(function () {
        var prev = btn.innerHTML;
        btn.innerHTML = '✓';
        setTimeout(function () { btn.innerHTML = prev; }, 1200);
      });
    });

    var searchInput = root.querySelector('#tdpFaqSearch');
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var query = searchInput.value.trim().toLowerCase();
        var activePanel = root.querySelector('.tdp-faq-panel.is-active');
        if (!activePanel) return;
        activePanel.querySelectorAll('.tdp-faq-item').forEach(function (item) {
          var match = !query || item.innerText.toLowerCase().indexOf(query) !== -1;
          item.classList.toggle('tdp-faq-hidden', !match);
        });
      });
    }
  }

  document.querySelectorAll('.tdp-faq').forEach(init);
  // Editeur de theme : section rechargee.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.tdp-faq').forEach(init);
  });
})();
